{
  "dodo.errors.idle.action": "再試行",
  "dodo.errors.idle.headline": "現在、サービス停止中",
  "dodo.errors.idle.line1": "後でもう一度試してください。",
  "dodo.maintenance.actionText": "ホームに戻る",
  "dodo.maintenance.description": "時折、重要なメンテナンスおよび/またはサービスのアップグレードを行うために短い休憩が必要です。ご理解いただき感謝しています。",
  "dodo.maintenance.headline": "申し訳ありませんが、現在定期メンテナンス中です"
}